import React from 'react';

import { Button } from '@hpstellar/core/visId';

import Link from '../../shared/components/hyperlink';
import ConditionalWrapper from '../../shared/components/conditional-wrapper';
import { withProductPrice } from '../../product/components/product-price/with-product-price';
import { TILEVARIANT } from './utils';

import './add-to-cart.less';

const EMPTY_OBJECT = {};

const AddToCart = props => {
    const {
        product = EMPTY_OBJECT,
        price = EMPTY_OBJECT,
        ctaLink,
        text,
        className,
        openModal,
        variant = TILEVARIANT.visId,
    } = props;
    const { stock, preOrder } = price;
    const { slug, prdClass } = product;
    let isParentPrd = prdClass === 'PRT';

    const pdpUrl = `/pdp/${slug}`;
    let ctaText;

    if (stock === 0 && !isParentPrd) {
        ctaText = TILEVARIANT.LifeStyleTile ? 'Out of Stock' : 'OUT OF STOCK';
    } else {
        ctaText = text.trim() || 'BUY NOW';
    }

    return (
        <ConditionalWrapper
            condition={ctaLink || stock === 0 || isParentPrd || preOrder}
            wrapper={children => {
                let linkUrl = ctaLink || pdpUrl;
                return <Link to={linkUrl}>{children}</Link>;
            }}
        >
            {variant === TILEVARIANT.LifeStyleTile ? (
                <Button
                    onClick={isParentPrd || stock === 0 || !!ctaLink ? null : openModal}
                    className={`lifestyle-add-to-cart${stock === 0 ? ` oos` : ''}`}
                    theme="dark"
                    size="small"
                    aria-label={ctaText}
                    disabled={!!ctaLink}
                >
                    {ctaText}
                </Button>
            ) : (
                <button
                    aria-label={ctaText}
                    className={'add-to-cart' + (className ? ` ${className}` : '')}
                    onClick={isParentPrd || stock === 0 || !!ctaLink ? null : openModal}
                >
                    {ctaText}
                </button>
            )}
        </ConditionalWrapper>
    );
};

AddToCart.defaultProps = {
    text: 'BUY NOW',
};

export default withProductPrice(AddToCart);
